// extracted by mini-css-extract-plugin
export default {"container":"Qaj5w3Plq6oLHwpQXjWA"};